import { render } from "./Formselect2.vue?vue&type=template&id=17886680"
import script from "./Formselect2.vue?vue&type=script&lang=js"
export * from "./Formselect2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__